import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { CssBaseline, ThemeProvider } from '@mui/material'
import { IntlProvider } from '@/core/translation'
import { ErrorBoundary } from '@/components'
import { theme } from '@/styles'
import { persistor, store } from '@/redux/core'
import { AppRouter } from '@/router'

export default function App() {
  return (
    <Provider store={store}>
      <IntlProvider>
        <PersistGate persistor={persistor}>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <ErrorBoundary>
              <AppRouter />
            </ErrorBoundary>
          </ThemeProvider>
        </PersistGate>
      </IntlProvider>
    </Provider>
  )
}
